<template>
    <div class="border rounded" style="border: 1px solid #d8d6de">
        <div :id="id" />
    </div>
</template>
<script>
import EditorJS from "@editorjs/editorjs";
// import Raw from "@editorjs/raw";
// import Link from "@editorjs/link";
import List from "@editorjs/list";
import Table from "@editorjs/table";
import Embed from "@mrkemaltas/embed";
import Marker from "@editorjs/marker";
import Header from "@editorjs/header";
import Warning from "@editorjs/warning";
import Attaches from "@editorjs/attaches";
import Underline from "@editorjs/underline";
import Delimiter from "@editorjs/delimiter";
import ImageTool from "@editorjs/image";
import Paragraph from "@editorjs/paragraph";
import Nestedlist from "@editorjs/nested-list";
import Personality from "@editorjs/personality";

import endpointPaths from "@/@core/endpoints/endpointPaths";
export default {
    components: {
        EditorJS,
        //Raw,
        List,
        Table,
        ImageTool,
        Embed,
        Marker,
        Header,
        Warning,
        Attaches,
        Underline,
        Delimiter,
        Paragraph,
        Nestedlist,
        Personality,
    },
    directives: {},
    props: {
        id: String,
        isLoaded: Boolean,
        text: {},
    },
    data() {
        return {
            eData: null,
            editor: null,
            sanitizerConfig: {
                h1: {}, // leave <b> without any attributes
                h2: {}, // leave <b> without any attributes
                h3: {}, // leave <b> without any attributes
                h4: {}, // leave <b> without any attributes
                h5: {}, // leave <b> without any attributes
                h6: {}, // leave <b> without any attributes
            },
        };
    },
    watch: {},
    methods: {
        myEditor: function () {
            var editor = new EditorJS({
                holder: this.id,
                autofocus: true,
                /**
                 * This Tool will be used as default
                 */
                initialBlock: "paragraph",
                data: this.text,
                /**
                 *
                 * Tools list
                 */
                tools: {
                    // raw: {
                    //   class: Raw,
                    // },
                    list: {
                        class: List,
                        inlineToolbar: true,
                    },
                    nestedlist: {
                        class: Nestedlist,
                        inlineToolbar: true,
                    },
                    table: {
                        class: Table,
                        inlineToolbar: true,
                    },
                    image: {
                        class: ImageTool,
                        config: {
                            endpoints: {
                                byFile: endpointPaths.upload.image, // Your backend file uploader endpoint
                                byUrl: endpointPaths.upload.imageByUrl, //our endpoint that provides uploading by Url
                            },
                            additionalRequestHeaders: {
                                'X-Requested-With': 'XMLHttpRequest',
                                'Authorization': `Bearer ${localStorage.getItem("accessToken")}`
                            }
                        },
                    },
                    embed: {
                        class: Embed,
                        inlineToolbar: true,
                    },
                    marker: {
                        class: Marker,
                        inlineToolbar: true,
                    },
                    header: {
                        class: Header,
                        inlineToolbar: true,
                    },
                    warning: {
                        class: Warning,
                        inlineToolbar: true,
                    },
                    attaches: {
                        class: Attaches,
                        config: {
                            endpoint: endpointPaths.upload.file,
                            additionalRequestHeaders: {
                                'X-Requested-With': 'XMLHttpRequest',
                                'Authorization': `Bearer ${localStorage.getItem("accessToken")}`
                            }
                        },
                    },
                    underline: {
                        class: Underline,
                        inlineToolbar: true,
                    },
                    delimiter: {
                        class: Delimiter,
                        inlineToolbar: true,
                    },
                    paragraph: {
                        class: Paragraph,
                        inlineToolbar: true,
                        config: {
                            placeholder: "Metin eklemek için tıklayın.",
                        },
                    },
                    // personality: {
                    //   class: Personality,
                    //   config: {
                    //     endpoint: endpointPaths.upload.image, // Your backend file uploader endpoint
                    //   },
                    // },
                },
                /**
                 * Internationalzation config
                 */
                i18n: {
                    /**
                     * @type {I18nDictionary}
                     */
                    messages: {
                        /**
                         * Other below: translation of different UI components of the editor.js core
                         */
                        ui: {
                            blockTunes: {
                                toggler: {
                                    "Click to tune": "Ayarlamak için tıklayın",
                                    "or drag to move": "veya taşımak için sürükleyin",
                                },
                            },
                            inlineToolbar: {
                                converter: {
                                    "Convert to": "Dönüştür",
                                },
                            },
                            toolbar: {
                                toolbox: {
                                    Add: "Ekle",
                                },
                            },
                        },
                        /**
                         * Section for translation Tool Names: both block and inline tools
                         */
                        toolNames: {
                            Text: "Metin",
                            Heading: "Başlık",
                            List: "Liste",
                            Nestedlist: "İç İçe Liste",
                            Warning: "Uyarı",
                            Checklist: "Kontrol Listesi",
                            Quote: "Alıntı",
                            Code: "Kod",
                            Delimiter: "Sınırlayıcı",
                            // "Raw HTML": "Ham HTML",
                            Table: "Tablo",
                            // Link: "Bağlantı",
                            Marker: "İşaretleyici",
                            Bold: "Bold",
                            Italic: "İtalik",
                            InlineCode: "Satır İçi Kod",
                            Image: "Görsel",
                            Underline: "Altıçizili",
                            Attaches: "Dosya",
                            Personality: "Kişi Profili",
                        },

                        /**
                         * Section for passing translations to the external tools classes
                         */
                        tools: {
                            /**
                             * Each subsection is the i18n dictionary that will be passed to the corresponded plugin
                             * The name of a plugin should be equal the name you specify in the 'tool' section for that plugin
                             */
                            warning: {
                                // <-- 'Warning' tool will accept this dictionary section
                                Title: "Başlık",
                                Message: "Mesaj",
                            },
                            /**
                             * Link is the internal Inline Tool
                             */
                            link: {
                                "Add a link": "Bağlantı ekle",
                            },
                            /**
                             * The "stub" is an internal block tool, used to fit blocks that does not have the corresponded plugin
                             */
                            stub: {
                                "The block can not be displayed correctly.":
                                    "Blok doğru görüntülenemiyor.",
                            },
                            personality: {
                                Name: "Ad",
                                Description: "Açıklama",
                                // Link: "Bağlantı",
                            },
                        },

                        /**
                         * Section allows to translate Block Tunes
                         */
                        blockTunes: {
                            /**
                             * Each subsection is the i18n dictionary that will be passed to the corresponded Block Tune plugin
                             * The name of a plugin should be equal the name you specify in the 'tunes' section for that plugin
                             *
                             * Also, there are few internal block tunes: "delete", "moveUp" and "moveDown"
                             */
                            delete: {
                                Delete: "Sil",
                            },
                            moveUp: {
                                "Move up": "Yukarı Taşı",
                            },
                            moveDown: {
                                "Move down": "Aşağı Taşı",
                            },
                        },
                    },
                },
                onReady: function () {
                    console.log("ready");
                },
                onChange: () => {
                    console.log("change");
                    editor.save().then((savedData) => {
                        this.eData = savedData;
                    }).catch((error) => console.log(error));
                },
            });
            this.editor = editor
        },
    },
    created() { },
    mounted: function () {
        this.eData = this.text
        this.myEditor();
    },
    setup() { },
};
</script>
<style  lang="css">
.codex-editor {
    padding-top: 20px;
}

.ce-block__content {
    max-width: 90% !important;
}

.ce-toolbar__content {
    max-width: 90% !important;
}
</style>